import {addAuthToFetchOpts} from '../../config/queryopts'
import {useMutationWithAuthentication} from "../index";
import {apiUrlInternal} from "../../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


const _ = require('lodash');


export const EditTicketFetcher = (accessToken, params) => {
  return axios.put(
    `${apiUrlInternal}/tickets/${params.uid}`, _.omit(params, ['uid']), addAuthToFetchOpts(accessToken, {})
  ).then(res => res);
}

export const usePriorityUpdateTicketMutation = (fetcher = EditTicketFetcher) => {
  const queryClient = useQueryClient()
  return useMutationWithAuthentication(
    ['update-priority-ticket'],
    (accessToken, params) => fetcher(accessToken, params),
    {
      onSuccess: (_, params) => {
        queryClient.invalidateQueries('update-priority-ticket')
        queryClient.invalidateQueries(['tickets', `/${params.uid}`])
      }
    }
  )
}

